// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IKDFP","wrapper":"styles_wrapper__3pn34","title":"styles_title__iKuwa","add-button":"styles_add-button__tNMKK","hint":"styles_hint__AVFZo"};